import Vue from "vue";
import axios from "axios";
import store from "../store";
import { MessageBox } from "element-ui";
import { Loading } from "element-ui";
import { showApploading, hideApploading } from "@/utils";
Vue.prototype.axios = axios;
import qs from "qs";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=utf-8;"; //设置文本提交类型
const baseServer = "https://sj.9d9d.vip";

//获取数据库表中信息
const getAxiosMethod = (URL, args = {}) => {
  let token = sessionStorage.getItem("token");
  if (token) {
    args.token = token;
  }
  return axios
    .get(baseServer + URL, { params: args })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
};

//提交客户端数据信息到数据库
const postAxiosMethod = (
  URL,
  args = {},
  options = { hideLoading: false, hideErorr: false }
) => {
  let token = sessionStorage.getItem("token");
  if (token) {
    args.token = token;
  }
  // let loadingInstance = Loading.service({
  //   spinner: "el-icon-loading",
  //   background: "rgba(255,255,255, 0.3)",
  // });

  if (!options.hideLoading) {
    console.log("showApploading", URL);
    showApploading();
  }

  return axios
    .post(baseServer + URL, qs.stringify(args))
    .then(function (res) {
      // loadingInstance.close();
      if (res.data.code !== 0 && options.hideErorr === false) {
        if (res.data.code === -1001) {
          document.activeElement.blur();
          MessageBox.alert(res.data.msg, "提示").then(() => {
            sessionStorage.clear();
            location.href = "/";
          });
        } else {
          document.activeElement.blur();
          MessageBox.alert(res.data.msg, "提示");
        }
      }
      return res.data;
    })
    .catch(function (e) {
      // loadingInstance.close();
      console.log(e);
      return;
    })
    .finally(() => hideApploading());
};

export default {
  getAxiosMethod,
  postAxiosMethod,
};
